<template>
    <div class="jom-dispformula" :class="{'iphone-style':isIphone}" :id="data.id">
      <table>
        <tbody><tr>
          <td width="42"></td>
          <td align="center" v-if="this.data.data && this.data.data.length > 0" style="white-space: nowrap">
            <component :is="'jo' + item.name" v-for="item in this.data.data" v-bind:key="item.index" v-bind:data="item.data"
                       v-bind:class="{'jom-dispformula-text':item.name=='text' && item.data.search(/[,.，。;；]/g)>=0}"></component>
          </td>
          <td width="80" align="right"><span class="index">
            <component :is="'jo' + item.name" v-for="item in this.data.label" v-bind:key="item.index" v-bind:data="item.data"></component>
          </span></td>
        </tr></tbody>
      </table>
    </div>
</template>

<script>
  import jomath from './math.vue'
  export default {
    components: {
      jomath
    },
    props: [
        'data'
    ],
    computed:{
      isIphone(){
        return navigator.userAgent.indexOf('iPhone')>0
      }
    }
  }
</script>
<style lang="scss" scoped>
    .jom-dispformula{
        padding:15px 0;
        /*margin:8px 0;*/
      overflow-x: auto;
      overflow-y: hidden;
      table{
        max-width: 100%;
        min-width: 50%;
        margin: 0 auto 0 auto;
        -webkit-border-horizontal-spacing: 0px;
        -webkit-border-vertical-spacing: 0px;
        font-size: 1.6rem;
        width: 100%;
        color: #333;
      }
      .jom-dispformula-text{
        vertical-align: bottom;
        span{
          vertical-align: bottom;
        }
      }
        .index{
            box-sizing:border-box;
            text-align:right;
            color: #333;
            font-weight: normal;
            font-size: 13px;
            flex:0 0 auto;
            display:flex;
            justify-content:flex-end;
            align-items:center;
        }
    }
  .iphone-style{
    padding:0 !important;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/formula/dispformula.vue